import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import SectionTitle from '@/components/base/SectionTitle';
import { faqs } from '@/mocks/drama';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6 max-w-4xl">
        <Reveal>
          <SectionTitle
            eyebrow="常见问题"
            title="关于本剧，大家最常问的几个问题"
            description="如果你在了解《漂亮的小姨子》时也有类似疑问，下面的整理可以直接给出方向。"
            align="center"
          />
        </Reveal>

        <div className="mt-10 space-y-3">
          {faqs.map((item, index) => {
            const open = openId === item.id;
            return (
              <Reveal key={item.id} delay={index * 40}>
                <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? null : item.id)}
                    aria-expanded={open}
                    className="flex w-full items-center gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="min-w-0 flex-1 font-heading text-sm md:text-base font-bold text-foreground-950">
                      {item.q}
                    </span>
                    <i className={`shrink-0 text-xl transition-transform ${open ? 'ri-subtract-line text-primary-600' : 'ri-add-line text-foreground-500'}`} aria-hidden="true" />
                  </button>
                  {open ? (
                    <div className="px-5 pb-5">
                      <p className="font-body text-sm leading-relaxed text-foreground-700">{item.a}</p>
                    </div>
                  ) : null}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}